<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-flask" titulo="PRODUÇÃO POR FÓRMULA">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{ registro.ID || 'Novo' }}</strong>
            </span>
            <span v-if="registro.OP_SITUACAO" class="mr-2">
              <b-badge :variant="getVariantStatus(registro.OP_SITUACAO)" pill>
                {{ getLabelStatus(registro.OP_SITUACAO) }}
              </b-badge>
            </span>
            <span v-if="registro.DESCRICAO" class="text-white-50">{{ registro.DESCRICAO }}</span>
          </div>
        </template>

        <template #acoes>
          <b-button v-if="itensFormula.length > 0" variant="link" class="btn-glass btn-glass-secondary px-4 font-weight-bold mr-2" @click.stop.prevent="imprimirEspelhoFormula">
            <i class="fa fa-file-text-o mr-1"></i> ESPELHO
          </b-button>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" :disabled="isBusy || !podeEditar" @click.stop.prevent="gravar">
            <i class="fa fa-save mr-1"></i> {{ registro.ID ? 'SALVAR' : 'GRAVAR' }}
          </b-button>
          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <b-row class="mb-3 align-items-stretch">
            <b-col xl="9" lg="12" class="mb-3 mb-xl-0">
              <b-card class="shadow-sm h-100 mb-0" :class="{'bg-dark border-secondary': isDark}">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                      <i class="fa fa-cogs"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Dados da Fórmula</h6>
                      <small class="text-muted">Defina o produto final e os parâmetros padrão da fórmula.</small>
                    </div>
                  </div>
                </template>

                <b-row>
                  <b-col md="5">
                    <label class="modal-label-premium">Produto Final *</label>
                    <ProducaoFormulaProdutoDropDown
                      v-model="registro.PRODUTO_ID"
                      modo="produto-final"
                      :idInicial="registro.PRODUTO_ID"
                      place="Pesquise o produto final..."
                      :classeRequired="!registro.PRODUTO_ID"
                      :desabilitarInput="!podeEditar">
                    </ProducaoFormulaProdutoDropDown>
                  </b-col>
                  <b-col md="4">
                    <label class="modal-label-premium">Descrição *</label>
                    <b-form-input v-model="registro.DESCRICAO" :disabled="!podeEditar" maxlength="100" class="rounded-pill shadow-xs" :class="{'is-invalid': !registro.DESCRICAO}"></b-form-input>
                  </b-col>
                  <b-col md="3">
                    <label class="modal-label-premium">Situação</label>
                    <div class="rounded-pill shadow-xs bg-light campo-desabilitado d-flex align-items-center justify-content-center status-badge-wrapper">
                      <b-badge :variant="getVariantStatus(registro.OP_SITUACAO)" pill class="px-3 py-2">
                        {{ getLabelStatus(registro.OP_SITUACAO) }}
                      </b-badge>
                    </div>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col md="3">
                    <label class="modal-label-premium">Produção Base (Quantidade) *</label>
                    <vue-autonumeric ref="edQuantPadrao" v-model="registro.QUANT_PADRAO" :options="formatoQuantidadePadrao" :class="['form-control rounded-pill shadow-xs text-right', { 'campo-invalido-vermelho': Number(registro.QUANT_PADRAO || 0) <= 0 }]" />
                    <small class="text-muted d-block mt-1">Quantidade total que esta fórmula produz na unidade principal do produto final.</small>
                  </b-col>
                  <b-col md="3">
                    <label class="modal-label-premium">Produção Base (Peças/Volumes)</label>
                    <vue-autonumeric v-model="registro.PECAS_PADRAO" :options="formatoPecas" class="form-control rounded-pill shadow-xs text-right" />
                    <small class="text-muted d-block mt-1">Quantidade de volumes/unidades geradas pela produção base. Use 0 quando não se aplicar.</small>
                  </b-col>
                  <b-col md="3">
                    <label class="modal-label-premium">Rendimento Previsto (%) *</label>
                    <vue-autonumeric v-model="registro.RENDIMENTO_PERC" :options="formatoPercentual" class="form-control rounded-pill shadow-xs text-right" />
                    <small class="text-muted d-block mt-1">Aproveitamento esperado da fórmula. Use 100 quando não houver perda planejada.</small>
                  </b-col>
                  <b-col md="3">
                    <label class="modal-label-premium">Total de Itens</label>
                    <b-form-input :value="resumoItens.totalItens" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-center font-weight-bold"></b-form-input>
                  </b-col>
                </b-row>

                <b-row class="mt-3">
                  <b-col md="12">
                    <label class="modal-label-premium">Observação</label>
                    <b-form-textarea v-model="registro.OBSERVACAO" rows="3" maxlength="200" class="shadow-xs" :disabled="!podeEditar"></b-form-textarea>
                  </b-col>
                </b-row>
              </b-card>
            </b-col>
            
            <b-col xl="3" lg="12">
              <b-card class="shadow-sm h-100 mb-0" :class="{'bg-dark border-secondary': isDark}">
                <template #header>
                  <div class="d-flex align-items-center">
                    <div class="bg-info text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                      <i class="fa fa-pie-chart"></i>
                    </div>
                    <div>
                      <h6 class="mb-0 font-weight-bold">Composição (%)</h6>
                    </div>
                  </div>
                </template>
                <div style="height: 250px;" class="d-flex align-items-center justify-content-center w-100">
                  <GraficoComposicaoFormula v-if="dadosGraficoComposicao" :chart-data="dadosGraficoComposicao" style="width: 100%; height: 100%;" />
                  <div v-else class="text-muted text-center">
                    <i class="fa fa-pie-chart fa-3x mb-2 opacity-50"></i>
                    <p class="mb-0 small">Nenhum percentual definido nos itens.</p>
                  </div>
                </div>
              </b-card>
            </b-col>
          </b-row>

          <b-card class="shadow-sm mb-3" :class="{'bg-dark border-secondary': isDark}">
            <template #header>
              <div class="d-flex flex-column flex-md-row align-items-md-center justify-content-between gap-2">
                <div class="d-flex align-items-center">
                  <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center section-icon">
                    <i class="fa fa-list-alt"></i>
                  </div>
                  <div>
                    <h6 class="mb-0 font-weight-bold">Itens da Fórmula</h6>
                    <small class="text-muted">Inclua as matérias-primas e os parâmetros de consumo da fórmula.</small>
                  </div>
                </div>
                <div>
                  <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm" :disabled="!registro.ID || !podeEditar" @click="novoItem">
                    <i class="fa fa-plus-circle mr-1"></i> Adicionar item
                  </b-button>
                </div>
              </div>
            </template>

            <b-alert v-if="!registro.ID" show variant="warning" class="mb-3">
              Grave o cabeçalho da fórmula para liberar a inclusão dos itens.
            </b-alert>

            <b-table
              v-if="registro.ID"
              :items="itensFormula"
              :fields="colunasItens"
              hover
              small
              responsive
              show-empty
              empty-text="Nenhum item cadastrado na fórmula"
              class="mb-0 table-finance">
              <template #cell(QUANTIDADE)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.QUANTIDADE, 3) }}</span>
              </template>

              <template #cell(PERCENTUAL)="row">
                <span class="text-right d-block">{{ formatarNumero(row.item.PERCENTUAL, 2) }}%</span>
              </template>

              <template #cell(actions)="row">
                <div class="d-flex justify-content-center gap-1">
                  <b-button variant="soft-primary" pill class="btn-icon-only shadow-sm" @click.stop.prevent="editarItem(row.item)" :disabled="!podeEditar" v-b-tooltip.hover title="Editar item">
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button variant="soft-danger" pill class="btn-icon-only shadow-sm" @click.stop.prevent="excluirItem(row.item)" :disabled="!podeEditar" v-b-tooltip.hover title="Excluir item">
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>
            </b-table>

            <div v-if="registro.ID" class="mt-3">
              <b-row>
                <b-col md="4">
                  <label class="modal-label-premium">Total de Itens</label>
                  <b-form-input :value="resumoItens.totalItens" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-center font-weight-bold"></b-form-input>
                </b-col>
                <b-col md="4">
                  <label class="modal-label-premium">Soma das Quantidades</label>
                  <b-form-input :value="formatarNumero(resumoItens.somaQuantidades, 3)" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-right font-weight-bold"></b-form-input>
                </b-col>
                <b-col md="4">
                  <label class="modal-label-premium">Soma dos Percentuais</label>
                  <b-form-input :value="formatarNumero(resumoItens.somaPercentuais, 2) + '%'" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-right font-weight-bold"></b-form-input>
                </b-col>
              </b-row>

              <b-alert v-if="alertaItensObrigatorios" show variant="danger" class="mt-3 mb-0">
                {{ alertaItensObrigatorios }}
              </b-alert>
              <b-alert v-if="alertaPercentuais" show variant="warning" class="mt-3 mb-0">
                {{ alertaPercentuais }}
              </b-alert>
              <b-alert v-if="alertaQuantidadeBase" show variant="warning" class="mt-3 mb-0">
                {{ alertaQuantidadeBase }}
              </b-alert>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </div>

    <b-modal
      ref="modalItem"
      id="modal-item-formula"
      header-class="p-0"
      no-close-on-esc
      no-close-on-backdrop
      centered
      body-class="p-0"
      size="lg"
      modal-class="premium-modal">
      <template #modal-header>
        <div class="bg-gradient-success w-100 p-3 d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <div class="bg-white-20 rounded-circle p-2 mr-3">
              <i class="fa fa-cube text-white"></i>
            </div>
            <div>
              <h5 class="mb-0 font-weight-bold text-white">{{ itemEmEdicao ? 'Editar Item da Fórmula' : 'Adicionar Item da Fórmula' }}</h5>
              <small class="text-white-50">Selecione a matéria-prima e defina o consumo padrão da produção base</small>
            </div>
          </div>
          <button type="button" class="close text-white" @click="fecharModalItem">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
      </template>

      <b-card no-body class="border-0">
        <div class="p-4 bg-white">
          <div class="modal-info-bar mb-4 bg-light border shadow-sm p-3 rounded">
            <b-row align-v="center">
              <b-col md="5">
                <small class="modal-label-premium">Fórmula</small>
                <h5 class="mb-0 font-weight-bold text-dark">{{ registro.ID || 'Nova' }} - {{ registro.DESCRICAO || 'Sem descrição' }}</h5>
              </b-col>
              <b-col md="4" class="border-left modal-info-bar-col text-md-right">
                <small class="modal-label-premium">Rendimento Previsto</small>
                <h5 class="mb-0 font-weight-bold text-success">{{ formatarNumero(registro.RENDIMENTO_PERC, 2) }}%</h5>
              </b-col>
              <b-col md="3" class="border-left modal-info-bar-col">
                <small class="modal-label-premium">Produção Base</small>
                <div class="font-weight-bold text-primary">{{ formatarNumero(registro.QUANT_PADRAO, 3) }}</div>
              </b-col>
            </b-row>
          </div>

          <div class="modal-section-title mb-3">
            <i class="fa fa-edit mr-2 text-primary"></i> Dados do Item da Fórmula
          </div>

          <b-row>
            <b-col md="12">
              <label class="modal-label-premium">Matéria-Prima *</label>
              <ProducaoFormulaProdutoDropDown
                v-model="itemModal.PRODUTO_ID"
                modo="materia-prima"
                :idInicial="itemModal.PRODUTO_ID"
                place="Pesquise a matéria-prima..."
                :classeRequired="!itemModal.PRODUTO_ID">
              </ProducaoFormulaProdutoDropDown>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="6">
              <label class="modal-label-premium">Centro de Estoque *</label>
              <CentroEstoqueDropDown v-model="itemModal.CENTRO_ESTOQUE_ID" :state="itemModal.CENTRO_ESTOQUE_ID ? null : false" :input-class="['rounded-pill', 'shadow-xs']"></CentroEstoqueDropDown>
            </b-col>
            <b-col md="3">
              <label class="modal-label-premium">Consumo na Produção Base *</label>
              <vue-autonumeric v-model="itemModal.QUANTIDADE" :options="formatoQuantidadeItem" :class="['form-control rounded-pill shadow-xs text-right', { 'is-invalid': Number(itemModal.QUANTIDADE || 0) <= 0 }]" />
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="4">
              <label class="modal-label-premium">% da Produção Base</label>
              <vue-autonumeric v-model="itemModal.PERCENTUAL" :options="formatoPercentual" class="form-control rounded-pill text-right shadow-xs"></vue-autonumeric>
            </b-col>
            <b-col md="4">
              <label class="modal-label-premium">Ordem</label>
              <b-form-input v-model.number="itemModal.ORDEM" type="number" min="1" class="rounded-pill shadow-xs text-right"></b-form-input>
            </b-col>
            <b-col md="4">
              <label class="modal-label-premium">Obrigar Lote</label>
              <b-form-input :value="itemModal.OP_OBRIGA_LOTE === '1' ? 'Sim' : 'Não'" disabled class="rounded-pill shadow-xs bg-light campo-desabilitado text-center"></b-form-input>
            </b-col>
          </b-row>

          <b-row class="mt-3">
            <b-col md="12">
              <label class="modal-label-premium">Observação</label>
              <b-form-textarea v-model="itemModal.OBSERVACAO" rows="3" maxlength="200" class="shadow-xs"></b-form-textarea>
            </b-col>
          </b-row>
        </div>
      </b-card>

      <template #modal-footer>
        <b-button variant="light" pill class="px-4 shadow-sm" @click="fecharModalItem">
          CANCELAR
        </b-button>
        <b-button variant="success" pill class="px-4 shadow-sm font-weight-bold" :disabled="salvandoItem" @click="salvarItem">
          <i class="fa fa-check mr-1"></i> {{ itemEmEdicao ? 'SALVAR ITEM' : 'ADICIONAR ITEM' }}
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import CentroEstoqueDropDown from '@/views/componentes/dropdown/CentroEstoqueDropDown.vue'
import ProducaoFormulaProdutoDropDown from './ProducaoFormulaProdutoDropDown.vue'
import VueAutonumeric from 'vue-autonumeric'
import GraficoComposicaoFormula from './GraficoComposicaoFormula.vue'

function escapeHtml(valor) {
  return String(valor == null ? '' : valor)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;')
}

function formatarDataHoraRelatorio() {
  return new Date().toLocaleString('pt-BR')
}

function novoRegistro() {
  return {
    ID: null,
    DESCRICAO: '',
    PRODUTO_ID: null,
    QUANT_PADRAO: 0,
    PECAS_PADRAO: 0,
    RENDIMENTO_PERC: 100,
    OP_SITUACAO: '1',
    OBSERVACAO: ''
  }
}

function novoItem(formulaId) {
  return {
    ID: null,
    PRD_FORMULA_ID: formulaId || null,
    PRODUTO_ID: null,
    CENTRO_ESTOQUE_ID: null,
    QUANTIDADE: 0,
    PERCENTUAL: 0,
    ORDEM: null,
    OP_TIPO_ITEM: 'M',
    OP_OBRIGA_LOTE: '0',
    OBSERVACAO: ''
  }
}

export default {
  components: {
    VueAutonumeric,
    HeaderPadrao,
    CentroEstoqueDropDown,
    ProducaoFormulaProdutoDropDown,
    GraficoComposicaoFormula
  },
  data() {
    return {
      isBusy: false,
      salvandoItem: false,
      empresaPreferencial: null,
      registro: novoRegistro(),
      itemModal: novoItem(),
      itemEmEdicao: false,
      formatoQuantidadePadrao: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '3',
        minimumValue: '0'
      },
      formatoQuantidadeItem: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '3',
        minimumValue: '0'
      },
      formatoPecas: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '0',
        minimumValue: '0'
      },
      formatoPercentual: {
        decimalCharacter: ',',
        digitGroupSeparator: '.',
        decimalCharacterAlternative: '.',
        roundingMethod: 'U',
        decimalPlaces: '2',
        minimumValue: '0'
      },
      colunasItens: [
        { key: 'ORDEM', label: 'Ordem', class: 'text-center', thStyle: { width: '80px' } },
        { key: 'PRODUTO_CODIGONOME', label: 'Matéria-Prima' },
        { key: 'CENTRO_ESTOQUE_CODIGONOME', label: 'Centro de Estoque' },
        { key: 'QUANTIDADE', label: 'Consumo na Produção Base', class: 'text-right', thStyle: { width: '180px' } },
        { key: 'PERCENTUAL', label: '% da Produção Base', class: 'text-right', thStyle: { width: '150px' } },
        { key: 'OBSERVACAO', label: 'Observação' },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    itensFormula() { return this.$store.getters['producaoFormula/ITENS_FORMULA'] || [] },
    resumoItens() {
      return this.itensFormula.reduce((resumo, item) => {
        resumo.totalItens += 1
        resumo.somaQuantidades += Number(item.QUANTIDADE || 0)
        resumo.somaPercentuais += Number(item.PERCENTUAL || 0)
        return resumo
      }, { totalItens: 0, somaQuantidades: 0, somaPercentuais: 0 })
    },
    alertaItensObrigatorios() {
      if (!this.registro.ID) return ''
      if (this.resumoItens.totalItens > 0) return ''
      return 'Inclua ao menos 1 item para manter a fórmula consistente.'
    },
    alertaPercentuais() {
      if (!this.registro.ID) return ''
      if (this.resumoItens.somaPercentuais <= 0) return ''
      if (Math.abs(this.resumoItens.somaPercentuais - 100) <= 0.0001) return ''
      return `A soma dos percentuais está em ${this.formatarNumero(this.resumoItens.somaPercentuais, 2)}%. Revise se a fórmula estiver sendo usada por percentual.`
    },
    alertaQuantidadeBase() {
      if (!this.registro.ID) return ''
      if (this.resumoItens.totalItens <= 0) return ''
      if (Number(this.registro.QUANT_PADRAO || 0) <= 0) return ''
      if (Math.abs(this.resumoItens.somaQuantidades - Number(this.registro.QUANT_PADRAO || 0)) <= 0.0001) return ''
      return `A soma das quantidades dos itens está em ${this.formatarNumero(this.resumoItens.somaQuantidades, 3)}, diferente da produção base informada (${this.formatarNumero(this.registro.QUANT_PADRAO, 3)}).`
    },
    possuiItensInvalidos() {
      return this.itensFormula.some(item => Number(item.QUANTIDADE || 0) <= 0 || Number(item.PERCENTUAL || 0) < 0)
    },
    podeEditar() { return String(this.registro.OP_SITUACAO || '1') !== '0' },
    dadosGraficoComposicao() {
      if (!this.itensFormula || this.itensFormula.length === 0) return null
      
      const itensComPercentual = this.itensFormula.filter(i => Number(i.PERCENTUAL || 0) > 0)
      if (itensComPercentual.length === 0) return null

      const labels = itensComPercentual.map(i => i.PRODUTO_CODIGONOME || 'Desconhecido')
      const data = itensComPercentual.map(i => Number(i.PERCENTUAL))
      
      const backgroundColors = [
        '#20a8d8', '#4dbd74', '#ffc107', '#f86c6b', '#6f42c1',
        '#e83e8c', '#fd7e14', '#20c997', '#6c757d', '#343a40',
        '#007bff', '#28a745', '#17a2b8', '#ffc107', '#dc3545'
      ]
      
      return {
        labels: labels,
        datasets: [{
          data: data,
          backgroundColor: backgroundColors.slice(0, data.length)
        }]
      }
    }
  },
  async mounted() {
    if (this.$route.params.id) {
      await this.carregarRegistro(this.$route.params.id)
    } else {
      this.$store.commit('producaoFormula/SET_ITENS_FORMULA', [])
    }
  },
  methods: {
    getLabelStatus(situacao) {
      return String(situacao || '1') === '0' ? 'Cancelada' : 'Ativa'
    },
    getVariantStatus(situacao) {
      return String(situacao || '1') === '0' ? 'danger' : 'success'
    },
    formatarNumero(valor, casas = 2) {
      return Number(valor || 0).toLocaleString('pt-BR', { minimumFractionDigits: casas, maximumFractionDigits: casas })
    },
    async obterEmpresaPreferencial() {
      if (this.empresaPreferencial) return this.empresaPreferencial
      const { data } = await this.$http.get('/api/protected/conferenciaFinanceira/empresa-preferencial')
      this.empresaPreferencial = data || {}
      return this.empresaPreferencial
    },
    montarHtmlEspelhoFormula(empresa) {
      const nomeUsuario = window.localStorage.getItem('nomeusuario') || window.localStorage.getItem('login') || 'sistema'
      const linhasItens = this.itensFormula.map((item, index) => `
        <tr>
          <td>${index + 1}</td>
          <td>${escapeHtml(item.ORDEM || '')}</td>
          <td>${escapeHtml(item.PRODUTO_CODIGONOME || '')}</td>
          <td>${escapeHtml(item.CENTRO_ESTOQUE_CODIGONOME || '')}</td>
          <td style="text-align:right;">${escapeHtml(this.formatarNumero(item.QUANTIDADE || 0, 3))}</td>
          <td style="text-align:right;">${escapeHtml(this.formatarNumero(item.PERCENTUAL || 0, 2))}%</td>
          <td style="text-align:center;">${escapeHtml(String(item.OP_OBRIGA_LOTE || '0') === '1' ? 'Sim' : 'Não')}</td>
          <td>${escapeHtml(item.OBSERVACAO || '')}</td>
        </tr>
      `).join('')

      return `<!doctype html>
      <html lang="pt-BR">
      <head>
        <meta charset="utf-8">
        <title>Espelho da Fórmula</title>
        <style>
          body { font-family: Arial, Helvetica, sans-serif; margin: 16px; color: #111; }
          .report-header { border: 1px solid #2f2f2f; }
          .report-header-top, .report-header-sub { display: flex; justify-content: space-between; padding: 4px 8px; font-size: 11px; border-bottom: 1px solid #2f2f2f; }
          .report-header-title { padding: 4px 8px; font-size: 12px; font-weight: 700; text-transform: uppercase; }
          .section { margin-top: 10px; }
          .section-title { font-size: 11px; font-weight: 700; margin-bottom: 4px; text-transform: uppercase; }
          .grid, .summary, .info-table { width: 100%; border-collapse: collapse; }
          .grid th, .grid td, .summary td, .info-table td { border: 1px solid #2f2f2f; padding: 4px 6px; font-size: 11px; vertical-align: top; }
          .grid th { background: #f2f2f2; text-align: left; }
          .summary td, .info-table td { width: 50%; }
          .signature-area { margin-top: 40px; }
          .signature-line { border-top: 1px solid #2f2f2f; width: 320px; padding-top: 6px; font-size: 11px; text-align: center; }
          .report-footer { position: fixed; left: 16px; right: 16px; bottom: 8px; display: flex; justify-content: space-between; font-size: 10px; border-top: 1px solid #2f2f2f; padding-top: 4px; background: #fff; }
          @media print { @page { size: A4 portrait; margin: 12mm; } body { margin: 0; } }
        </style>
      </head>
      <body>
        <div class="report-header">
          <div class="report-header-top">
            <div><strong>${escapeHtml(empresa.FANTASIA || empresa.RAZAO_RELATORIO || empresa.RAZAO || 'CECWEB')}</strong></div>
            <div><strong>Usuário:</strong> ${escapeHtml(nomeUsuario)}</div>
          </div>
          <div class="report-header-title">Espelho da Fórmula de Produção</div>
          <div class="report-header-sub">
            <div>${escapeHtml(empresa.NOME_EMPRESA || '')}</div>
            <div><strong>Emitido em:</strong> ${escapeHtml(formatarDataHoraRelatorio())}</div>
          </div>
          <div class="report-header-sub" style="border-bottom:0;">
            <div><strong>Produto Final:</strong> ${escapeHtml(this.registro.PRODUTO_CODIGONOME || this.registro.PRODUTO_ID || '')}</div>
            <div><strong>Situação:</strong> ${escapeHtml(this.getLabelStatus(this.registro.OP_SITUACAO))}</div>
          </div>
        </div>

        <div class="section">
          <div class="section-title">Dados da fórmula</div>
          <table class="info-table">
            <tr>
              <td><strong>ID:</strong> ${escapeHtml(this.registro.ID || 'Novo')}</td>
              <td><strong>Descrição:</strong> ${escapeHtml(this.registro.DESCRICAO || '')}</td>
            </tr>
            <tr>
              <td><strong>Produção Base:</strong> ${escapeHtml(this.formatarNumero(this.registro.QUANT_PADRAO || 0, 3))}</td>
              <td><strong>Peças/Volumes:</strong> ${escapeHtml(this.formatarNumero(this.registro.PECAS_PADRAO || 0, 0))}</td>
            </tr>
            <tr>
              <td><strong>Rendimento Previsto:</strong> ${escapeHtml(this.formatarNumero(this.registro.RENDIMENTO_PERC || 0, 2))}%</td>
              <td><strong>Total de Itens:</strong> ${escapeHtml(this.resumoItens.totalItens)}</td>
            </tr>
            <tr>
              <td><strong>Soma das Quantidades:</strong> ${escapeHtml(this.formatarNumero(this.resumoItens.somaQuantidades || 0, 3))}</td>
              <td><strong>Soma dos Percentuais:</strong> ${escapeHtml(this.formatarNumero(this.resumoItens.somaPercentuais || 0, 2))}%</td>
            </tr>
            <tr>
              <td colspan="2"><strong>Observação:</strong> ${escapeHtml(this.registro.OBSERVACAO || '')}</td>
            </tr>
          </table>
        </div>

        <div class="section">
          <div class="section-title">Itens da fórmula</div>
          <table class="grid">
            <thead>
              <tr>
                <th style="width:36px;">#</th>
                <th style="width:60px;">Ordem</th>
                <th style="width:180px;">Matéria-Prima</th>
                <th style="width:160px;">Centro de Estoque</th>
                <th style="width:110px; text-align:right;">Consumo Base</th>
                <th style="width:90px; text-align:right;">% Base</th>
                <th style="width:60px; text-align:center;">Lote</th>
                <th>Observação</th>
              </tr>
            </thead>
            <tbody>
              ${linhasItens}
            </tbody>
          </table>
        </div>

        <div class="signature-area">
          <div class="signature-line">Assinatura do usuário responsável</div>
        </div>

        <div class="report-footer">
          <div>Impresso em: ${escapeHtml(formatarDataHoraRelatorio())}</div>
          <div>Qtd. itens: ${escapeHtml(this.resumoItens.totalItens)}</div>
          <div>Usuário: ${escapeHtml(nomeUsuario)}</div>
        </div>
      </body>
      </html>`
    },
    async imprimirEspelhoFormula() {
      if (!this.itensFormula.length) {
        this.$bvToast.toast('Cadastre ou carregue os itens da fórmula antes de gerar o espelho.', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      const janela = window.open('', '_blank')
      if (!janela) {
        this.$bvToast.toast('O navegador bloqueou a abertura da nova aba do espelho.', {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      try {
        const empresa = await this.obterEmpresaPreferencial()
        const html = this.montarHtmlEspelhoFormula(empresa)
        janela.document.open('text/html', 'replace')
        janela.document.write(html)
        janela.document.close()
        janela.focus()
      } catch (err) {
        janela.close()
        this.$bvToast.toast(err?.response?.data || err?.message || 'Erro ao gerar espelho da fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    },
    voltar() {
      this.$router.push('/producao/formula/listagem')
    },
    async carregarRegistro(id) {
      this.isBusy = true
      try {
        const registro = await this.$store.dispatch('producaoFormula/GET_BY_ID', id)
        this.registro = { ...novoRegistro(), ...registro }
        await this.carregarItens(id)
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao carregar fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
        this.voltar()
      } finally {
        this.isBusy = false
      }
    },
    async carregarItens(id) {
      await this.$store.dispatch('producaoFormula/GET_ITENS', id)
    },
    validarRegistro() {
      if (!this.registro.PRODUTO_ID) return 'Informe o produto final da fórmula'
      if (!this.registro.DESCRICAO || !this.registro.DESCRICAO.trim()) return 'Informe a descrição da fórmula'
      if (Number(this.registro.QUANT_PADRAO || 0) <= 0) return 'Informe a produção base (quantidade) maior que zero'
      if (Number(this.registro.PECAS_PADRAO || 0) < 0) return 'Informe uma produção base de peças/volumes válida'
      if (Number(this.registro.RENDIMENTO_PERC || 0) <= 0 || Number(this.registro.RENDIMENTO_PERC || 0) > 100) return 'Informe um rendimento previsto maior que zero e menor ou igual a 100'
      if (this.registro.ID && this.resumoItens.totalItens <= 0) return 'Inclua ao menos 1 item para salvar a fórmula'
      if (this.possuiItensInvalidos) return 'Revise os itens da fórmula. Existem quantidades, peças ou percentuais inválidos'
      return ''
    },
    async gravar() {
      const erro = this.validarRegistro()
      if (erro) {
        this.$bvToast.toast(erro, {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.isBusy = true
      try {
        const url = this.registro.ID ? '/api/protected/producao-formula/edit' : '/api/protected/producao-formula/post'
        const { data } = await this.$http.post(url, {
          login: window.localStorage.getItem('login') || 'SISTEMA',
          registro: this.registro
        })

        const registroSalvo = data[0]
        this.registro = { ...novoRegistro(), ...registroSalvo }
        this.$store.commit('producaoFormula/SET_FORMULA_ATUAL', this.registro)
        this.$store.commit('producaoFormula/SET_RECARREGAR_LISTA', true)

        if (!this.$route.params.id) {
          await this.$router.replace(`/producao/formula/edit/${this.registro.ID}`)
        }

        await this.carregarItens(this.registro.ID)

        this.$bvToast.toast('Fórmula gravada com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao gravar fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.isBusy = false
      }
    },
    novoItem() {
      this.itemEmEdicao = false
      this.itemModal = novoItem(this.registro.ID)
      this.$refs.modalItem.show()
    },
    editarItem(item) {
      this.itemEmEdicao = true
      this.itemModal = { ...novoItem(this.registro.ID), ...item }
      this.$refs.modalItem.show()
    },
    fecharModalItem() {
      this.$refs.modalItem.hide()
    },
    validarItem() {
      if (!this.itemModal.PRODUTO_ID) return 'Informe a matéria-prima do item'
      if (!this.itemModal.CENTRO_ESTOQUE_ID) return 'Informe o centro de estoque do item'
      if (Number(this.itemModal.QUANTIDADE || 0) <= 0) return 'Informe uma quantidade maior que zero'
      if (Number(this.itemModal.PERCENTUAL || 0) < 0) return 'Informe um percentual válido'

      const repetido = this.itensFormula.some(item => item.PRODUTO_ID === this.itemModal.PRODUTO_ID && item.ID !== this.itemModal.ID)
      if (repetido) return 'Não é permitido repetir o mesmo item na fórmula'

      return ''
    },
    async salvarItem() {
      const erro = this.validarItem()
      if (erro) {
        this.$bvToast.toast(erro, {
          title: 'Aviso',
          variant: 'warning',
          solid: true
        })
        return
      }

      this.salvandoItem = true
      try {
        const url = this.itemModal.ID ? '/api/protected/producao-formula-item/edit' : '/api/protected/producao-formula-item/post'
        await this.$http.post(url, {
          login: window.localStorage.getItem('login') || 'SISTEMA',
          registro: {
            ...this.itemModal,
            PRD_FORMULA_ID: this.registro.ID
          }
        })

        await this.carregarItens(this.registro.ID)
        this.$refs.modalItem.hide()

        this.$bvToast.toast('Item gravado com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao gravar item da fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      } finally {
        this.salvandoItem = false
      }
    },
    async excluirItem(item) {
      const confirmou = await this.$bvModal.msgBoxConfirm(`Confirma a exclusão do item ${item.PRODUTO_CODIGONOME}?`, {
        title: 'Excluir item da fórmula',
        centered: true,
        okVariant: 'danger',
        okTitle: 'Excluir',
        cancelTitle: 'Cancelar'
      })

      if (!confirmou) return

      try {
        await this.$http.post('/api/protected/producao-formula-item/delete', { id: item.ID })
        await this.carregarItens(this.registro.ID)
        this.$bvToast.toast('Item excluído com sucesso', {
          title: 'Sucesso',
          variant: 'success',
          solid: true
        })
      } catch (err) {
        this.$bvToast.toast(err?.response?.data || 'Erro ao excluir item da fórmula', {
          title: 'Erro',
          variant: 'danger',
          solid: true
        })
      }
    }
  }
}
</script>

<style scoped>
.section-icon {
  width: 40px;
  height: 40px;
}

.table-finance tbody td {
  vertical-align: middle !important;
}

::v-deep .premium-modal .modal-content {
  border: none !important;
  border-radius: 16px !important;
  overflow: hidden;
  box-shadow: 0 15px 35px rgba(50, 50, 93, 0.2), 0 5px 15px rgba(0, 0, 0, 0.17) !important;
}

::v-deep .premium-modal .modal-body {
  padding: 0 !important;
}

.status-badge-wrapper {
  min-height: 38px;
}

.modal-info-bar-col {
  min-height: 54px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.modal-section-title {
  display: flex;
  align-items: center;
  font-size: 0.82rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #6c757d;
}

.bg-gradient-success {
  background: linear-gradient(135deg, #2eb85c 0%, #1f9d4b 100%) !important;
}

.bg-white-20 {
  background: rgba(255, 255, 255, 0.2) !important;
}

.campo-invalido-vermelho {
  border-color: #f86c6b !important;
  box-shadow: 0 0 0 0.2rem rgba(248, 108, 107, 0.2) !important;
}
</style>


// WEBPACK FOOTER //
// src/views/producao/producao-formula/ProducaoFormulaCadastro.vue